import { ComponentPropsWithoutRef, FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';

import styles from './icon.less';

interface IconDynamicProps extends ComponentPropsWithoutRef<'div'> {
    /** На всю ширину */
    stretched?: boolean;
}

const IconDynamic: FC<PropsWithChildren<IconDynamicProps>> = ({ stretched = false, ...iconDynamicProps }) => {
    const forceDisabled = useDisabled();

    return (
        <div
            className={classnames(styles['icon-dynamic'], {
                [styles.iconDynamicFullWidth]: stretched,
                [styles.iconDynamicDisabled]: forceDisabled,
            })}
            {...iconDynamicProps}
        />
    );
};

export default IconDynamic;
